
(() => {
  const bindBuyNow = (root = document) => {
    root.querySelectorAll('[data-legacy-buy-now]:not([data-bound])').forEach((button) => {
      button.dataset.bound = 'true';
      button.addEventListener('click', async () => {
        const form = button.closest('form');
        if (!form || button.disabled) return;
        const original = button.innerHTML;
        button.disabled = true;
        button.innerHTML = '<span>Processing…</span><span aria-hidden="true">↗</span>';
        try {
          const response = await fetch(form.action, {
            method: 'POST', body: new FormData(form),
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error('Unable to add item');
          window.location.assign('/checkout');
        } catch (error) {
          button.disabled = false;
          button.innerHTML = original;
          const addButton = form.querySelector('[name="add"]');
          if (addButton) addButton.click();
        }
      });
    });
  };
  bindBuyNow();
  document.addEventListener('shopify:section:load', (event) => bindBuyNow(event.target));
  new MutationObserver(() => bindBuyNow()).observe(document.documentElement, { childList:true, subtree:true });
})();
